<p-card class="p-fluid p-formgrid grid tw-w-full">
  <div class="field col-12">
    <brt-ui-settings [(ngModel)]="reward.UI" [keys]="['Title']"></brt-ui-settings>
  </div>
  <div class="field col-6">
    <label htmlFor="cost">Cost</label>
    <p-inputNumber [(ngModel)]="reward.Cost" id="cost" suffix=" point(s)"></p-inputNumber>
  </div>
  <div class="field col-6">
    <label htmlFor="voucher-code">Voucher Code</label>
    <div class="tw-text-gray-400 tw-text-xs">If set each user can use One free</div>
    <input pInputText [(ngModel)]="reward.VoucherCode" id="voucher-code" />
  </div>
  <div class="field col-12">
    <label htmlFor="items">Items</label>
    @for(item of reward.Items; track $index){
    <p-card class="tw-flex tw-flex-row tw-gap-2 col-12">
      <div class="field">
        <label htmlFor="item-credit">Credit</label>
        <p-inputNumber [(ngModel)]="item.Credit" id="item-credit" mode="currency" currency="GBP"></p-inputNumber>
      </div>
      <div class="field">
        <label htmlFor="item-discount">Discount</label>
        <p-inputNumber [(ngModel)]="item.DiscountPercentage" id="item-discount" suffix="%"></p-inputNumber>
      </div>
      <div class="field">
        <label htmlFor="item-free-delivery">Free Delivery</label>
        <div id="item-free-delivery">
          <p-inputSwitch [(ngModel)]="item.FreeDelivery"></p-inputSwitch>
        </div>
      </div>
      <div class="field">
        <label htmlFor="item-quantity">Quantity</label>
        <div id="item-quantity">
          <p-inputNumber [(ngModel)]="item.Quantity" id="item-quantity" [min]="1" [step]="1"></p-inputNumber>
        </div>
      </div>
      <div class="field tw-flex-grow tw-justify-end">
        <p-button icon="pi pi-trash" (click)="reward.Items.splice($index, 1)" severity="danger"></p-button>
      </div>
    </p-card>
    }
  </div>
  <div class="field col-3">
    <p-button (click)="reward.Items.push({})" icon="pi pi-plus" label="Add Item"></p-button>
  </div>
  <div class="p-fluid">
    <button pButton pRipple label="Save" (click)="save()"></button>
  </div>
</p-card>